import { usePageNavigate } from '../../app/navigation';
import React from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router';
import { Button } from '../ui/Button';
import { Alert } from '../ui/Alert';

export const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError();
  const navigate = usePageNavigate();

  let title = 'An unexpected error occurred';
  let message = 'Please try navigating back or reloading the page.';
  let code = 'ERROR';

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = '404 - Not Found';
      message =
        (error.data as { detail?: string })?.detail ||
        'The requested statutory resource or route does not exist.';
      code = 'NOT_FOUND';
    } else {
      title = `Error ${error.status}`;
      message = error.statusText;
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div style={{ maxWidth: 640, margin: '40px auto', padding: '0 20px' }}>
      <Alert variant="danger" title={title}>
        <p style={{ margin: '8px 0' }}>{message}</p>
        <code style={{ fontSize: 12, opacity: 0.8 }}>Code: {code}</code>
      </Alert>
      <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
        <Button
          variant="primary"
          onClick={() => {
            void navigate('/');
          }}
        >
          Return to Corpus Overview
        </Button>
        <Button variant="secondary" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </div>
  );
};
